import { ColorPalette } from 'theme/colors';

export type ThemeType = typeof Theme;

export const Theme = {
  space: [0, 2, 4, 8, 16, 32],
  loading: ColorPalette.HEX.Gainsboro,
  device: {
    mobile: 'only screen and (max-width: 1024px)',
    desktop: 'only screen and (min-width: 1025px)',
  },
  desktop: {
    header: {
      height: 65,
      background: ColorPalette.HEX.White,
      color: ColorPalette.HEX.OriolesOrange,
    },
    menu: {
      itemWidth: 75,
      itemHeight: 75,
      smallItemHeight: 50,
      expandedWidth: 300,
    },
  },
  mobile: {
    background: ColorPalette.HEX.Lotion,
  },
  index: {
    color: ColorPalette.HEX.OuterSpace,
    icons: ColorPalette.HEX.DimGray,
  },
  floatingActionButton: {
    background: `linear-gradient(225deg, ${ColorPalette.HEX.RedPigment}, ${ColorPalette.HEX.PortlandOrange})`,
    shadow: `rgba(${ColorPalette.RGB.Black}, 0.3)`,
  },
  cardHotel: {
    activeStar: ColorPalette.HEX.SizzlingSunrise,
    inactiveStar: ColorPalette.HEX.LightSilver,
  },
  tabs: {
    totalSpentContainerBorderBottom: ColorPalette.HEX.BrightGray,
    active: ColorPalette.HEX.PortlandOrange,
    disabled: ColorPalette.HEX.Manatee,
    background: '#EFECE9',
    rounded: {
      activeBackground: ColorPalette.HEX.PineTree,
      inactiveBackground: ColorPalette.HEX.White,
      activeColor: ColorPalette.HEX.White,
      inactiveColor: ColorPalette.HEX.DimGray2,
    },
  },
  notFound: {
    header: ColorPalette.HEX.OriolesOrange,
    text: ColorPalette.HEX.OuterSpace,
  },
  airportsSearch: {
    placeHolder: ColorPalette.HEX.Manatee,
    background: ColorPalette.HEX.White,
    resultItemBorder: ColorPalette.HEX.BrightGray,
    recentSearches: ColorPalette.HEX.DimGray,
    airportCode: ColorPalette.HEX.DimGray,
    recentSearchesBackground: ColorPalette.HEX.AntiFlashWhite,
    hover: ColorPalette.HEX.FloralWhite,
  },
  flightLine: {
    line: `linear-gradient(90deg, rgba(${ColorPalette.RGB.VividGamboge},1) -38%, rgba(${ColorPalette.RGB.RedPigment2},1) 100%);`,
    textColor: ColorPalette.HEX.DimGray,
    point: ColorPalette.HEX.OriolesOrange2,
    boxShadow: `0 0 0 2px ${ColorPalette.HEX.OriolesOrange}`,
  },
  basicLayout: {
    backgroundColor: ColorPalette.HEX.Cultured,
  },
  bottomSheet: {
    background: ColorPalette.HEX.White,
    headerBorder: ColorPalette.HEX.LightSilver,
    draggerBackground: ColorPalette.HEX.LightGray,
    titleColor: ColorPalette.HEX.OuterSpace2,
    backdrop: `rgba(${ColorPalette.RGB.Black}, .3)`,
  },
  bottomSheetOptions: {
    borderItem: ColorPalette.HEX.BrightGray,
    hover: ColorPalette.HEX.FloralWhite,
  },
  box: {
    borderColor: ColorPalette.HEX.GraniteGray,
  },
  button: {
    disabled: ColorPalette.HEX.MetallicSilver,
    enabled: ColorPalette.HEX.PastelRed,
    background: `linear-gradient(99deg, ${ColorPalette.HEX.AtomicTangerine}, ${ColorPalette.HEX.RedPigment2})`,
    invertedBackground: ColorPalette.HEX.White,
    color: ColorPalette.HEX.White,
    invertedColor: ColorPalette.HEX.OriolesOrange,
    containerBorder: ColorPalette.HEX.BrightGray,
    containerBackground: ColorPalette.HEX.Lotion,
  },
  buttonListModal: {
    icon: ColorPalette.HEX.PineTree,
    background: ColorPalette.HEX.White,
    border: ColorPalette.HEX.BrightGray,
    color: ColorPalette.HEX.QuickSilver,
    error: ColorPalette.HEX.TartOrange,
  },
  cardLoader: {
    background: `linear-gradient(90deg, ${ColorPalette.HEX.White}, ${ColorPalette.HEX.Platinum}, ${ColorPalette.HEX.White}, ${ColorPalette.HEX.Platinum})`,
  },
  cardFlight: {
    primary: ColorPalette.HEX.OuterSpace,
    secondary: ColorPalette.HEX.Manatee,
    background: ColorPalette.HEX.White,
    border: ColorPalette.HEX.BrightGray2,
    cardShadow: `rgba(${ColorPalette.RGB.Black}, 0.1)`,
  },
  cardUser: {
    icon: ColorPalette.HEX.White,
    background: ColorPalette.HEX.White,
    itemShadow: `rgba(${ColorPalette.RGB.WhiteCoffee}, 0.5)`,
    usernameColor: ColorPalette.HEX.PineTree,
    userEmailColor: ColorPalette.HEX.DimGray,
    cancelButtonBorder: ColorPalette.HEX.AmericanSilver,
    cancelButtonColor: ColorPalette.HEX.PineTree,
  },
  checkbox: {
    checked: ColorPalette.HEX.OriolesOrange,
    empty: ColorPalette.HEX.White,
    border: ColorPalette.HEX.MetallicSilver,
    disabled: ColorPalette.HEX.DimGray,
  },
  links: {
    color: ColorPalette.HEX.OriolesOrange,
  },
  dateRangePicker: {
    background: ColorPalette.HEX.White,
    headerShadow: `rgba(${ColorPalette.RGB.Black}, 0.2)`,
    titleColor: ColorPalette.HEX.DimGray,
    backgroundMonth: ColorPalette.HEX.AntiFlashWhite,
    monthColor: ColorPalette.HEX.DimGray,
    color: ColorPalette.HEX.White,
    selectedDate: ColorPalette.HEX.OriolesOrange,
    selectedLabel: ColorPalette.HEX.OuterSpace,
    undefinedDate: ColorPalette.HEX.Manatee,
    buttonShadow: `linear-gradient(to bottom, rgba(${ColorPalette.RGB.White}, 0) 0, rgba(${ColorPalette.RGB.White},0.4) 24px,rgba(${ColorPalette.RGB.White},0.8))`,
  },
  field: {
    color: ColorPalette.HEX.TartOrange,
  },
  flightsHeader: {
    color: ColorPalette.HEX.DimGray,
    titleColor: ColorPalette.HEX.PineTree,
    inforColor: ColorPalette.HEX.DimGray,
  },
  hotelsHeader: {
    color: ColorPalette.HEX.DimGray,
    inforColor: ColorPalette.HEX.DimGray,
  },
  autosHeader: {
    color: ColorPalette.HEX.DimGray,
    titleColor: ColorPalette.HEX.PineTree,
    inforColor: ColorPalette.HEX.DimGray,
  },
  appBar: {
    background: ColorPalette.HEX.White,
    shadow: `rgba(${ColorPalette.RGB.WhiteCoffee}, 0.5)`,
    color: ColorPalette.HEX.DimGray,
    back: ColorPalette.HEX.Manatee,
  },
  header: {
    icon: ColorPalette.HEX.PineTree,
  },
  input: {
    color: ColorPalette.HEX.DarkCharcoal,
    errorColor: ColorPalette.HEX.TartOrange,
    border: ColorPalette.HEX.BrightGray,
    valid: ColorPalette.HEX.Apple,
    prefixSuffix: ColorPalette.HEX.PineTree,
    prefixSuffixBackground: ColorPalette.HEX.BrightGray,
    active: {
      prefixSuffix: ColorPalette.HEX.White,
      prefixSuffixBackground: ColorPalette.HEX.DimGray,
    },
  },
  loader: {
    color: ColorPalette.HEX.BlueVioletCrayola,
    backgroundColor: ColorPalette.HEX.White,
  },
  modalList: {
    icon: ColorPalette.HEX.White,
    usernameColor: ColorPalette.HEX.PineTree,
    userEmailColor: ColorPalette.HEX.DimGray,
  },
  monthPicker: {
    weekBorder: ColorPalette.HEX.BrightGray,
    weekdayColor: ColorPalette.HEX.OuterSpace,
    monthDayActiveBackground: `linear-gradient(0, ${ColorPalette.HEX.PortlandOrange} 0%, ${ColorPalette.HEX.RedPigment} 100%)`,
    monthDayActiveColor: ColorPalette.HEX.White,
    dayColor: ColorPalette.HEX.OuterSpace,
    monthRangeDay: ColorPalette.HEX.Linen,
    outdated: ColorPalette.HEX.Manatee,
    inRange: ColorPalette.HEX.OriolesOrange,
  },
  bookingSelect: {
    border: ColorPalette.HEX.BrightGray,
    labelColor: ColorPalette.HEX.DimGray,
    valueColor: ColorPalette.HEX.OuterSpace,
    topLabelColor: ColorPalette.HEX.DimGray,
  },
  optionsBookingSelect: {
    color: ColorPalette.HEX.OuterSpace,
    background: ColorPalette.HEX.White,
    shadow: `rgba(${ColorPalette.RGB.Black}, 0.1)`,
    line: ColorPalette.HEX.BrightGray,
    activeBackground: ColorPalette.HEX.AntiFlashWhite,
  },
  searchInput: {
    text: {
      height: '80px',
      padding: '0 15px',
      border: 'none',
      boxShadow: `0 0 20px 0 rgba(${ColorPalette.RGB.PineTree}, 0.05)`,
      label: {
        fontSize: '18px',
        color: ColorPalette.HEX.PineTree,
      },
      detail: {
        fontSize: '12px',
        color: ColorPalette.HEX.PineTree,
      },
      placeholder: {
        label: {
          color: ColorPalette.HEX.DimGray2,
        },
        detail: {
          color: ColorPalette.HEX.PhilippineSilver,
        },
      },
    },
    date: {
      background: ColorPalette.HEX.White,
      boxShadow: `0 0 20px 0 rgba(${ColorPalette.RGB.PineTree}, 0.05)`,
      height: '80px',
      padding: '0 15px',
      border: 'none',
      label: {
        fontSize: '18px',
        color: ColorPalette.HEX.PineTree,
        marginTop: '24px',
      },
      detail: {
        fontSize: '12px',
        color: ColorPalette.HEX.DimGray2,
        top: '15px',
      },
      placeholder: {
        label: {
          color: ColorPalette.HEX.PhilippineSilver,
        },
      },
      disabled: {
        background: ColorPalette.HEX.Cultured2,
        border: `1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25)`,
        boxShadow: 'none',
        label: {
          color: ColorPalette.HEX.PhilippineSilver,
        },
      },
    },
    time: {
      background: ColorPalette.HEX.White,
      boxShadow: `0 0 20px 0 rgba(${ColorPalette.RGB.PineTree}, 0.05)`,
      height: '80px',
      padding: '0 15px',
      border: 'none',
      label: {
        fontSize: '18px',
        color: ColorPalette.HEX.PineTree,
        marginTop: '24px',
      },
      detail: {
        fontSize: '12px',
        color: ColorPalette.HEX.DimGray2,
        top: '15px',
      },
      placeholder: {
        label: {
          color: ColorPalette.HEX.PhilippineSilver,
        },
      },
      disabled: {
        background: ColorPalette.HEX.Cultured2,
        border: `1px solid rgba(${ColorPalette.RGB.PhilippineSilver}, 0.25)`,
        boxShadow: 'none',
        label: {
          color: ColorPalette.HEX.PhilippineSilver,
        },
      },
    },
    travelArranger: {
      background: ColorPalette.HEX.White,
      boxShadow: `0 0 20px 0 rgba(${ColorPalette.RGB.PineTree}, 0.05)`,
      height: '80px',
      padding: '0 15px',
      border: 'none',
      label: {
        fontSize: '18px',
        color: ColorPalette.HEX.PineTree,
        marginTop: '24px',
      },
      detail: {
        fontSize: '12px',
        color: ColorPalette.HEX.DimGray2,
        top: '15px',
        display: 'block',
      },
      guest: {
        fontSize: '14px',
        color: ColorPalette.HEX.Manatee,
      },
      placeholder: {
        label: {
          color: ColorPalette.HEX.PhilippineSilver,
        },
      },
    },
  },
  simpleHeader: {
    icon: ColorPalette.HEX.White,
    background: ColorPalette.HEX.White,
    shadow: `rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16)`,
    titleColor: ColorPalette.HEX.PineTree,
  },
  stepper: {
    activeBackground: ColorPalette.HEX.RedRYB,
    background: ColorPalette.HEX.Manatee,
  },
  switch: {
    background: ColorPalette.HEX.AntiFlashWhite,
    gradientBackground: `linear-gradient(0, ${ColorPalette.HEX.PortlandOrange} 0%, ${ColorPalette.HEX.RedPigment} 100%)`,
    active: ColorPalette.HEX.White,
    inactive: ColorPalette.HEX.DimGray,
  },
  navigationMenu: {
    background: ColorPalette.HEX.FloralWhite,
    border: ColorPalette.HEX.BrightGray,
    avatarBorder: ColorPalette.HEX.LightSilver,
    profileColor: ColorPalette.HEX.Manatee,
    doneColor: ColorPalette.HEX.OriolesOrange,
  },
  adminForm: {
    titleColor: ColorPalette.HEX.OuterSpace,
  },
  adminFormPassword: {
    titleColor: ColorPalette.HEX.OuterSpace,
    subtitleColor: ColorPalette.HEX.DimGray,
  },
  booking: {
    screenBackground: ColorPalette.HEX.White,
    headerBackground: ColorPalette.HEX.AntiFlashWhite,
  },
  companyForm: {
    titleColor: ColorPalette.HEX.OuterSpace,
    subtitleColor: ColorPalette.HEX.DimGray,
  },
  countrySelection: {
    border: ColorPalette.HEX.BrightGray,
  },
  flightsList: {
    background: ColorPalette.HEX.White,
    switchBackground: ColorPalette.HEX.DavysGrey,
    switch: ColorPalette.HEX.Manatee,
    resultsCount: ColorPalette.HEX.Manatee,
    notFound: ColorPalette.HEX.Manatee,
    filter: ColorPalette.HEX.DeepCarminePink,
    filterContainerBoxShadow: `rgba(${ColorPalette.RGB.Black}, 0.55)`,
    filterDivider: ColorPalette.HEX.TartOrange,
    filterSwitchOffColor: ColorPalette.HEX.Manatee,
    filterSwitchOnColor: ColorPalette.HEX.OriolesOrange,
  },
  group: {
    white: ColorPalette.HEX.White,
    whiteGrey: ColorPalette.HEX.Lotion,
    division: ColorPalette.HEX.BrightGray,
    section: {
      title: ColorPalette.HEX.PineTree,
      details: ColorPalette.HEX.Manatee,
    },
    subTitleBackground: ColorPalette.HEX.AntiFlashWhite,
    subTitle: ColorPalette.HEX.DimGray,
    tutorial: ColorPalette.HEX.OuterSpace,
    selectUsers: ColorPalette.HEX.OriolesOrange,
    modalConfirmationText: ColorPalette.HEX.OuterSpace,
    selectedUsersText: ColorPalette.HEX.DimGray,
    selectedUsersBoxShadow: `rgba(${ColorPalette.RGB.WhiteCoffee}, 0.9)`,
    selectedUsersBoxBackground: ColorPalette.HEX.White,
    budgetTitle: ColorPalette.HEX.OuterSpace,
    textColor: ColorPalette.HEX.OuterSpace,
    sectionTitle: ColorPalette.HEX.OuterSpace,
    sectionDetails: ColorPalette.HEX.OuterSpace3,
    label: ColorPalette.HEX.DimGray,
    approvalMethodTitle: ColorPalette.HEX.PineTree,
  },
  groupList: {
    color: ColorPalette.HEX.PineTree,
    iconColor: ColorPalette.HEX.DimGray,
    background: ColorPalette.HEX.AntiFlashWhite,
    cardBackground: ColorPalette.HEX.White,
    imageBackground: 'transparent',
    shadow: `rgba(${ColorPalette.RGB.WhiteCoffee}, 0.5)`,
    groupUsers: ColorPalette.HEX.DimGray,
    borderColor: ColorPalette.HEX.BrightGray,
    emptyView: {
      title: ColorPalette.HEX.OriolesOrange,
      text: ColorPalette.HEX.OuterSpace,
    },
  },
  groupAdd: {
    background: ColorPalette.HEX.White,
  },
  groupedList: {
    item: {
      textColor: ColorPalette.HEX.DimGray,
      backgroundContainer: ColorPalette.HEX.White,
      background: ColorPalette.HEX.AntiFlashWhite,
      headTextColor: ColorPalette.HEX.PineTree,
      backgroundHover: ColorPalette.HEX.FloralWhite,
      division: ColorPalette.HEX.BrightGray,
    },
  },
  walkThrough: {
    color: ColorPalette.HEX.CharlestonGreen,
    background: ColorPalette.HEX.White,
    backgroundHeader: `linear-gradient(270deg, ${ColorPalette.HEX.RedPigment} 0%, ${ColorPalette.HEX.PortlandOrange} 100%)`,
  },
  citiesSearch: {
    background: ColorPalette.HEX.White,
    shadow: `rgba(${ColorPalette.RGB.Black}, 0.2)`,
    searchPlaceholderColor: ColorPalette.HEX.Manatee,
    resultItemColor: ColorPalette.HEX.BrightGray,
    optionsHover: ColorPalette.HEX.FloralWhite,
    recentColor: ColorPalette.HEX.DimGray,
    recentBackground: ColorPalette.HEX.AntiFlashWhite,
  },
  flightSearch: {
    kindLabel: ColorPalette.HEX.DimGray,
    baggage: ColorPalette.HEX.Manatee,
  },
  flightDetails: {
    background: ColorPalette.HEX.White,
    bestOptionBackground: `linear-gradient(258deg, ${ColorPalette.HEX.BlueViolet} 100%, ${ColorPalette.HEX.BlueViolet2})`,
    preApprovedBackground: `linear-gradient(258deg, ${ColorPalette.HEX.UFOGreen} 100%, ${ColorPalette.HEX.PastelGreen})`,
    costExceededColor: ColorPalette.HEX.CongoPink,
    costExceededBackground: ColorPalette.HEX.Seashell,
    infoText: ColorPalette.HEX.White,
    InfoStar: ColorPalette.HEX.SizzlingSunrise,
    checkoutItem: ColorPalette.HEX.DimGray,
    checkoutTotal: ColorPalette.HEX.OuterSpace,
    checkoutTotalApproved: ColorPalette.HEX.Apple,
    checkoutTotalExceeded: ColorPalette.HEX.CongoPink,
    division: ColorPalette.HEX.AntiFlashWhite,
    border: ColorPalette.HEX.BrightGray,
    card: {
      title: ColorPalette.HEX.OuterSpace,
      boxShadow: `rgba(${ColorPalette.RGB.Black}, 0.1)`,
      arrowDown: ColorPalette.HEX.OuterSpace,
    },
    cancellationPolicies: {
      cardContent: ColorPalette.HEX.LightSilver2,
      label: ColorPalette.HEX.OuterSpace,
      policy: ColorPalette.HEX.OuterSpace,
      policyValue: ColorPalette.HEX.Manatee,
      disclaimer: ColorPalette.HEX.OuterSpace,
    },
    price: {
      title: ColorPalette.HEX.OuterSpace,
      label: ColorPalette.HEX.Manatee2,
      division: ColorPalette.HEX.LightSilver2,
      priceValue: ColorPalette.HEX.OuterSpace4,
      boxShadow: `rgba(${ColorPalette.RGB.Black}, 0.1)`,
    },
  },
  flightsDetails: {
    color: ColorPalette.HEX.OuterSpace,
  },
  flightSector: {
    shadow: `rgba(${ColorPalette.RGB.Black}, 0.1)`,
    background: ColorPalette.HEX.White,
    division: ColorPalette.HEX.BrightGray3,
    primary: ColorPalette.HEX.OuterSpace,
    secondary: ColorPalette.HEX.Manatee,
    infoBackground: ColorPalette.HEX.AntiFlashWhite,
    info: ColorPalette.HEX.DimGray,
  },
  flightSectorBaggage: {
    shadow: `rgba(${ColorPalette.RGB.Black}, 0.1)`,
    luggage: ColorPalette.HEX.OuterSpace,
    includeLuggage: ColorPalette.HEX.OriolesOrange3,
    division: ColorPalette.HEX.LightSilver2,
    restrictions: ColorPalette.HEX.Manatee,
  },
  dataCardHotels: {
    background: ColorPalette.HEX.White,
    shadow: `rgba(${ColorPalette.RGB.Black}, 0.1)`,
    border: ColorPalette.HEX.BrightGray,
    gradient: `linear-gradient(259deg, ${ColorPalette.HEX.UFOGreen}, ${ColorPalette.HEX.PastelGreen})`,
    labelTextColor: ColorPalette.HEX.White,
    cleanColor: ColorPalette.HEX.DimGray,
    fullPriceColor: ColorPalette.HEX.OuterSpace5,
    hotelTitle: ColorPalette.HEX.OuterSpace,
    icon: ColorPalette.HEX.White,
  },
  hotelsList: {
    background: ColorPalette.HEX.White,
    icon: ColorPalette.HEX.DeepCarminePink,
    notFound: ColorPalette.HEX.White,
    filter: ColorPalette.HEX.White,
    switchBackground: ColorPalette.HEX.DavysGrey,
    switch: ColorPalette.HEX.Manatee,
    resultsCount: ColorPalette.HEX.Manatee,
    mapPinBackground: ColorPalette.HEX.CoralRed,
  },
  hotelDetails: {
    boxShadow: ColorPalette.HEX.Alabaster,
    background: ColorPalette.HEX.White,
    shadow: `rgba(${ColorPalette.RGB.WhiteCoffee}, 0.5)`,
    subtitleColor: ColorPalette.HEX.OuterSpace,
    infoColor: ColorPalette.HEX.OuterSpace,
    separator: ColorPalette.HEX.BrightGray,
    confirmArea: `linear-gradient(258deg, ${ColorPalette.HEX.RedPigment} 100%, ${ColorPalette.HEX.PortlandOrange})`,
    confirmAreaColor: ColorPalette.HEX.White,
    roomTitleColor: ColorPalette.HEX.OuterSpace,
    mapContainer: ColorPalette.HEX.Yellow,
    detailCard: ColorPalette.HEX.Alabaster,
    bookingInfo: ColorPalette.HEX.AntiFlashWhite,
    bottomAddress: ColorPalette.HEX.DimGray,
    bookingInfoDates: ColorPalette.HEX.PhilippineSilver2,
    refundable: ColorPalette.HEX.Emerald,
    nonRefundable: ColorPalette.HEX.OriolesOrange,
    seeMore: ColorPalette.HEX.OriolesOrange,
    bestOption: `linear-gradient(258deg, ${ColorPalette.HEX.BlueViolet} 100%, ${ColorPalette.HEX.BlueViolet2})`,
    white: ColorPalette.HEX.White,
    selection: `linear-gradient(250deg, ${ColorPalette.HEX.RedPigment} 100%, ${ColorPalette.HEX.PortlandOrange})`,
    strongGrey: ColorPalette.HEX.OuterSpace,
    minorGrey: ColorPalette.HEX.DimGray,
    red: ColorPalette.HEX.OriolesOrange,
    green: ColorPalette.HEX.Emerald,
  },
  activeColor: {
    confirmColor: ColorPalette.HEX.PastelGreen2,
  },
  userMenu: {
    avatarColor: ColorPalette.HEX.CongoPink,
    profileColor: ColorPalette.HEX.Verdigris,
    doneColor: ColorPalette.HEX.OriolesOrange,
    settingsColor: ColorPalette.HEX.White,
    line: ColorPalette.HEX.BrightGray,
    initials: ColorPalette.HEX.White,
    initialsBackground: ColorPalette.HEX.DimGray,
    background: ColorPalette.HEX.White,
    circleBorder: ColorPalette.HEX.CoralRed2,
    color: ColorPalette.HEX.DimGray,
    nameColor: ColorPalette.HEX.OuterSpace,
    subTitleBackground: ColorPalette.HEX.AntiFlashWhite,
  },
  users: {
    textColor: ColorPalette.HEX.PineTree,
    buttonTextColor: ColorPalette.HEX.OriolesOrange,
    userGroups: ColorPalette.HEX.DimGray,
  },
  usersList: {
    textColor: ColorPalette.HEX.OuterSpace,
    cardShadow: `rgba(${ColorPalette.RGB.WhiteCoffee}, 0.5)`,
    cardBackground: ColorPalette.HEX.White,
    dataColor: ColorPalette.HEX.DimGray,
    userName: ColorPalette.HEX.OuterSpace,
    imageBackground: 'transparent',
  },
  usersListModal: {
    background: ColorPalette.HEX.White,
  },
  userForm: {
    textColor: ColorPalette.HEX.OuterSpace,
    color: ColorPalette.HEX.PineTree,
    border: ColorPalette.HEX.AmericanSilver,
    background: ColorPalette.HEX.White,
    modalConfirmationTextColor: ColorPalette.HEX.OuterSpace,
  },
  userFormSuccess: {
    emailColor: ColorPalette.HEX.OriolesOrange,
  },
  cardGroup: {
    icon: ColorPalette.HEX.White,
    background: ColorPalette.HEX.White,
    itemShadow: `rgba(${ColorPalette.RGB.WhiteCoffee}, 0.5)`,
    groupNameColor: ColorPalette.HEX.DimGray,
    groupCorporateColor: ColorPalette.HEX.DimGray,
    cancelButtonBorder: ColorPalette.HEX.TartOrange,
    cancelButtonColor: ColorPalette.HEX.TartOrange,
    groupUsers: {
      border: ColorPalette.HEX.White,
      background: ColorPalette.HEX.AntiFlashWhite,
      moreUsers: ColorPalette.HEX.OriolesOrange4,
      moreUsersBackground: ColorPalette.HEX.Seashell,
    },
  },
  confirmationModal: {
    buttonColor: ColorPalette.HEX.OriolesOrange,
    buttonBackground: ColorPalette.HEX.White,
  },
  travelDetails: {
    locatorEticketLabel: ColorPalette.HEX.OuterSpace,
    background: ColorPalette.HEX.White,
    initialsBackground: ColorPalette.HEX.DimGray,
    initials: ColorPalette.HEX.White,
    color: ColorPalette.HEX.DimGray,
    line: ColorPalette.HEX.BrightGray,
    sectionsTitle: ColorPalette.HEX.OuterSpace,
    limitExceeded: ColorPalette.HEX.TartOrange,
    limitApproved: ColorPalette.HEX.PastelGreen2,
    acceptButtonBackground: `linear-gradient(to left, ${ColorPalette.HEX.UFOGreen}, ${ColorPalette.HEX.PastelGreen})`,
    acceptButtonColor: ColorPalette.HEX.White,
    flightsShadow: `rgba(${ColorPalette.RGB.Black}, 0.1)`,
    circleBorder: ColorPalette.HEX.CoralRed2,
    cardShadow: ColorPalette.HEX.Alabaster,
    border: ColorPalette.HEX.BrightGray3,
    refundable: ColorPalette.HEX.Emerald,
    nonRefundable: ColorPalette.HEX.OriolesOrange,
    red: ColorPalette.HEX.OriolesOrange,
    green: ColorPalette.HEX.Emerald,
  },
  travelReport: {
    header: {
      color: ColorPalette.HEX.DimGray,
      inforColor: ColorPalette.HEX.DimGray,
    },
    itemShadow: `rgba(${ColorPalette.RGB.WhiteCoffee}, 0.9)`,
    imageBackground: 'transparent',
    title: ColorPalette.HEX.White,
    background: `linear-gradient(65deg, ${ColorPalette.HEX.GargoyleGas} -80%, ${ColorPalette.HEX.PhilippineOrange} 97%)`,
    separator: ColorPalette.HEX.BrightGray3,
    color: ColorPalette.HEX.OuterSpace,
  },
  flightStops: {
    color: ColorPalette.HEX.DimGray,
    line: ColorPalette.HEX.BrightGray,
    companys: ColorPalette.HEX.Manatee,
    division: ColorPalette.HEX.AntiFlashWhite,
  },
  flightSeeMore: {
    color: ColorPalette.HEX.DimGray,
    division: ColorPalette.HEX.AntiFlashWhite,
  },
  listComponent: {
    borderLine: ColorPalette.HEX.BrightGray,
  },
  expandableList: {
    boxShadow: `rgba(${ColorPalette.RGB.Black}, 0.18)`,
    primary: ColorPalette.HEX.OuterSpace,
    secondary: ColorPalette.HEX.DimGray,
  },
  groupsSelectableList: {
    groupName: ColorPalette.HEX.OuterSpace,
  },
  rule: {
    greyLight: ColorPalette.HEX.DimGray,
    sectionTitle: ColorPalette.HEX.PineTree,
    background: ColorPalette.HEX.Lotion,
    division: ColorPalette.HEX.BrightGray,
    groups: {
      background: ColorPalette.HEX.White,
    },
    restriction: {
      boxShadow: `rgba(${ColorPalette.RGB.Black}, 0.18)`,
      border: ColorPalette.HEX.BrightGray,
      background: ColorPalette.HEX.White,
      title: ColorPalette.HEX.OuterSpace,
    },
    specific: {
      background: ColorPalette.HEX.White,
      about: {
        boxShadow: `rgba(${ColorPalette.RGB.Black}, 0.1)`,
        color: ColorPalette.HEX.OuterSpace,
      },
      bottomAlert: {
        color: ColorPalette.HEX.OuterSpace,
      },
    },
    ruleList: {
      primary: ColorPalette.HEX.OriolesOrange,
      white: ColorPalette.HEX.White,
      lightGrey: ColorPalette.HEX.BrightGray,
    },
  },
  bottomAlert: {
    color: ColorPalette.HEX.OuterSpace,
  },
  rulesComponent: {
    iconBackground: `linear-gradient(225deg, ${ColorPalette.HEX.RedPigment}, ${ColorPalette.HEX.PortlandOrange})`,
    iconCounter: ColorPalette.HEX.White,
    iconBackgroundDisabled: ColorPalette.HEX.AntiFlashWhite,
    iconCounterDisabled: ColorPalette.HEX.DimGray,
    lightGrey: ColorPalette.HEX.BrightGray,
    distanceButtonBackground: `linear-gradient(253deg, ${ColorPalette.HEX.RedPigment}, ${ColorPalette.HEX.PortlandOrange})`,
    distanceColor: ColorPalette.HEX.White,
    successScreen: ColorPalette.HEX.AntiFlashWhite,
    doneText: ColorPalette.HEX.OriolesOrange,
    rulesGroupSelect: ColorPalette.HEX.OuterSpace,
  },
  rulesList: {
    iconColor: ColorPalette.HEX.DimGray,
    background: ColorPalette.HEX.White,
    itemShadow: `rgba(${ColorPalette.RGB.WhiteCoffee}, 0.9)`,
    imageBackground: 'transparent',
    color: ColorPalette.HEX.DimGray,
  },
  travelApproval: {
    screenBackground: ColorPalette.HEX.White,
    headerBackground: ColorPalette.HEX.AntiFlashWhite,
    list: {
      labelName: ColorPalette.HEX.DimGray,
      labelPrice: ColorPalette.HEX.OuterSpace,
      labelDate: ColorPalette.HEX.DimGray,
      buttonReject: ColorPalette.HEX.CongoPink,
      buttonAprrove: ColorPalette.HEX.Apple,
    },
    modal: {
      modalTextColor: ColorPalette.HEX.DimGray,
    },
    summaryCard: {
      title: ColorPalette.HEX.White,
      description: ColorPalette.HEX.White,
    },
  },
  travelReaquested: {
    screenBackground: ColorPalette.HEX.White,
    headerBackground: ColorPalette.HEX.AntiFlashWhite,
    list: {
      labelFlight: ColorPalette.HEX.DimGray,
      labelHotelCity: ColorPalette.HEX.DimGray,
      labelPrice: ColorPalette.HEX.OuterSpace,
      labelDate: ColorPalette.HEX.DimGray,
      iconColor: ColorPalette.HEX.DimGray,
      imageBackground: `rgba(${ColorPalette.RGB.BlueViolet3}, 0.2)`,
    },
  },
  toastComponent: {
    successBackground: `linear-gradient(74deg, ${ColorPalette.HEX.BlackOlive} 0%, ${ColorPalette.HEX.RaisinBlack} 100%)`,
    dangerBackground: ColorPalette.HEX.TartOrange,
    toastColor: ColorPalette.HEX.White,
  },
  responseScreen: {
    title: ColorPalette.HEX.OriolesOrange,
    text: ColorPalette.HEX.OuterSpace,
    background: ColorPalette.HEX.AntiFlashWhite,
    close: ColorPalette.HEX.White,
    backgroundImage: ColorPalette.HEX.White,
  },
  dashboard: {
    card: {
      shadow: `rgba(${ColorPalette.RGB.UFOGreen2}, 0.2)`,
      background: {
        green: `linear-gradient(to left, ${ColorPalette.HEX.UFOGreen}, ${ColorPalette.HEX.PastelGreen})`,
        orange: `linear-gradient(32deg, ${ColorPalette.HEX.GargoyleGas} -62%, ${ColorPalette.HEX.PhilippineOrange} 99%)`,
        purple: `linear-gradient(to left, ${ColorPalette.HEX.BlueViolet}, ${ColorPalette.HEX.BlueViolet2})`,
      },
      colorText: ColorPalette.HEX.White,
      border: ColorPalette.HEX.BrightGray,
      seeMore: ColorPalette.HEX.PortlandOrange,
      preApprovedTag: `linear-gradient(258deg, ${ColorPalette.HEX.UFOGreen}, ${ColorPalette.HEX.PastelGreen})`,
      breakTag: ColorPalette.HEX.Seashell,
      breakTagText: ColorPalette.HEX.CongoPink,
    },
    messageEmptyColor: ColorPalette.HEX.DimGray,
    messageNameColor: ColorPalette.HEX.DimGray,
    messageColor: ColorPalette.HEX.OuterSpace,
    dropdownColor: ColorPalette.HEX.Mantis,
  },
  filters: {
    background: ColorPalette.HEX.White,
    shadow: `rgba(${ColorPalette.RGB.Black}, 0.2)`,
    line: ColorPalette.HEX.BrightGray,
    color: ColorPalette.HEX.OuterSpace,
    icon: ColorPalette.HEX.Manatee,
    placeHolder: ColorPalette.HEX.Manatee,
  },
  filtersBottomSheet: {
    background: ColorPalette.HEX.White,
    shadow: `rgba(${ColorPalette.RGB.Black}, 0.2)`,
    line: ColorPalette.HEX.BrightGray,
    color: ColorPalette.HEX.PineTree,
    icon: ColorPalette.HEX.PineTree,
    placeHolder: ColorPalette.HEX.Manatee,
  },
  starsFilter: {
    color: ColorPalette.HEX.OuterSpace,
    active: ColorPalette.HEX.White,
  },
  joyRide: {
    arrow: `linear-gradient(73deg, ${ColorPalette.HEX.BlackOlive} 0%, ${ColorPalette.HEX.RaisinBlack} 100%)`,
    background: ColorPalette.HEX.RaisinBlack,
    colorText: ColorPalette.HEX.White,
    backgroundImage: `linear-gradient(74deg, ${ColorPalette.HEX.BlackOlive} 0%, ${ColorPalette.HEX.RaisinBlack} 100%)`,
  },
  emptyList: {
    titleColor: ColorPalette.HEX.OriolesOrange,
    descriptionColor: ColorPalette.HEX.DimGray,
    greyBackground: `rgb(${ColorPalette.RGB.AntiFlashWhite})`,
    whiteBackground: ColorPalette.HEX.White,
    imageBackgroundGradient: `linear-gradient(to bottom, ${ColorPalette.HEX.White}, ${ColorPalette.HEX.White})`,
  },
  userListBottomSheet: {
    btnConfirm: `linear-gradient(to left, ${ColorPalette.HEX.UFOGreen}, ${ColorPalette.HEX.PastelGreen})`,
    btnCancel: ColorPalette.HEX.TartOrange,
  },
  breakTag: {
    color: ColorPalette.HEX.CongoPink,
    background: ColorPalette.HEX.Seashell,
    brightColor: ColorPalette.HEX.White,
    brightBackground: ColorPalette.HEX.TartOrange,
  },
  requestCard: {
    border: ColorPalette.HEX.BrightGray3,
    textColor: ColorPalette.HEX.OuterSpace,
    shadow: `rgba(${ColorPalette.RGB.Black}, 0.18)`,
    showMore: ColorPalette.HEX.OriolesOrange,
    borderImage: `linear-gradient(to bottom, rgba(${ColorPalette.RGB.White}, 0.2), rgba(${ColorPalette.RGB.White}, 0.1) 5%,rgba(${ColorPalette.RGB.White}, 0) 20%,rgba(${ColorPalette.RGB.White}, 0) )`,
    backgroundImage: `linear-gradient(to bottom, ${ColorPalette.HEX.White}, ${ColorPalette.HEX.White}),linear-gradient(to bottom,rgba(${ColorPalette.RGB.White}, 0.2),rgba(${ColorPalette.RGB.White}, 0.1) 5%,rgba(${ColorPalette.RGB.White}, 0) 20%, rgba(${ColorPalette.RGB.White}, 0))`,
    background: ColorPalette.HEX.White,
    buttonCancelColor: ColorPalette.HEX.TartOrange,
    color: ColorPalette.HEX.White,
    buttonSuccessColor: `linear-gradient(to left, ${ColorPalette.HEX.UFOGreen}, ${ColorPalette.HEX.PastelGreen})`,
  },
  confirmation: {
    color: ColorPalette.HEX.OuterSpace,
    background: ColorPalette.HEX.White,
    cancelButtonColor: ColorPalette.HEX.TartOrange,
    backgroundConfirmButton: `linear-gradient(to left, ${ColorPalette.HEX.UFOGreen}, ${ColorPalette.HEX.PastelGreen})`,
  },
  airlineException: {
    textColor: ColorPalette.HEX.OuterSpace,
    textButtonColor: ColorPalette.HEX.OriolesOrange,
    divider: ColorPalette.HEX.BrightGray,
  },
  airlinesList: {
    background: ColorPalette.HEX.White,
    border: ColorPalette.HEX.BrightGray,
    textColor: ColorPalette.HEX.OuterSpace,
  },
  simpleCard: {
    cardHeaderText: ColorPalette.HEX.DimGray,
    cardBgColor: ColorPalette.HEX.White,
    cardShadow: `rgba(${ColorPalette.RGB.WhiteCoffee}, 0.9)`,
  },
  expensesSuccess: {
    color: ColorPalette.HEX.PortlandOrange,
  },
  travelCard: {
    color: ColorPalette.HEX.White,
    background: `linear-gradient(to bottom, rgba(${ColorPalette.RGB.Black}, 0.4), rgba(${ColorPalette.RGB.ChineseBlack}, 0.9))`,
  },
  travelWithExpensesList: {
    titleColor: ColorPalette.HEX.PineTree,
    subtitleColor: ColorPalette.HEX.DimGray,
    expenseCardBackground: `linear-gradient(to right, ${ColorPalette.HEX.BlueViolet2} 0%, ${ColorPalette.HEX.BlueViolet} 100%)`,
    expenseCardColor: ColorPalette.HEX.White,
  },
  expensesList: {
    primary: ColorPalette.HEX.PineTree,
    secondary: ColorPalette.HEX.DimGray,
    report: ColorPalette.HEX.OriolesOrange,
    whiteBackground: ColorPalette.HEX.White,
  },
  imagePicker: {
    background: ColorPalette.HEX.White,
    buttonTextColor: ColorPalette.HEX.CoralRed,
    trashTextColor: ColorPalette.HEX.OriolesOrange,
    label: ColorPalette.HEX.DimGray,
    shadow: `rgba(${ColorPalette.RGB.Black}, 0.1)`,
  },
  expense: {
    background: ColorPalette.HEX.Lotion,
    deleteButton: ColorPalette.HEX.OriolesOrange,
    values: {
      division: ColorPalette.HEX.BrightGray,
      title: ColorPalette.HEX.OuterSpace,
    },
    types: {
      division: ColorPalette.HEX.BrightGray,
      background: ColorPalette.HEX.White,
      label: ColorPalette.HEX.DimGray,
      active: {
        background: `linear-gradient(98deg, ${ColorPalette.HEX.AtomicTangerine}, ${ColorPalette.HEX.RedPigment2} 100%)`,
        label: ColorPalette.HEX.White,
      },
    },
  },
  roomCard: {
    boxShadow: ColorPalette.HEX.Alabaster,
    background: ColorPalette.HEX.White,
    refundable: ColorPalette.HEX.Emerald,
    nonRefundable: ColorPalette.HEX.OriolesOrange,
    strongGrey: ColorPalette.HEX.OuterSpace,
    minorGrey: ColorPalette.HEX.DimGray,
    red: ColorPalette.HEX.OriolesOrange,
    green: ColorPalette.HEX.Emerald,
    separator: ColorPalette.HEX.BrightGray,
  },
  guestCard: {
    titleColor: ColorPalette.HEX.OuterSpace,
    infoTitle: ColorPalette.HEX.Manatee,
    infoContent: ColorPalette.HEX.OuterSpace,
    boxShadow: `rgba(${ColorPalette.RGB.Black}, 0.1)`,
  },
  termsOfService: {
    background: ColorPalette.HEX.White,
    termsLink: ColorPalette.HEX.OriolesOrange,
    checkboxLabelColor: ColorPalette.HEX.DimGray,
  },
  styledListItem: {
    primary: ColorPalette.HEX.OuterSpace,
    secondary: ColorPalette.HEX.DimGray,
    groupTag: {
      emptyBackground: ColorPalette.HEX.AntiFlashWhite,
      background: ColorPalette.HEX.Seashell,
      color: ColorPalette.HEX.OriolesOrange4,
    },
  },
  approvalsTag: {
    color: ColorPalette.HEX.SafetyOrange,
    backgroundColor: ColorPalette.HEX.VeryPaleOrange,
  },
  withinPoliticsTag: {
    color: ColorPalette.HEX.GreenPantone,
    background: ColorPalette.HEX.MagicMint,
  },
  expirationTag: {
    coloredBackground: `linear-gradient(76deg, ${ColorPalette.HEX.GargoyleGas} -54%, ${ColorPalette.HEX.PhilippineOrange} 96%)`,
    normalBackground: ColorPalette.HEX.White,
    normalColor: ColorPalette.HEX.DimGray,
    white: ColorPalette.HEX.White,
    border: ColorPalette.HEX.BrightGray,
  },
  customSelect: {
    primary: ColorPalette.HEX.DimGray,
  },
  searchSelect: {
    primary: ColorPalette.HEX.DimGray,
  },
  travelReportFilter: {
    primary: ColorPalette.HEX.OuterSpace,
    optionsItems: {
      primary: ColorPalette.HEX.OuterSpace,
      background: ColorPalette.HEX.White,
      shadow: `rgba(${ColorPalette.RGB.Black}, 0.1)`,
      line: ColorPalette.HEX.BrightGray,
      activeBackground: ColorPalette.HEX.AntiFlashWhite,
    },
  },
  timeline: {
    line: ColorPalette.HEX.BrightGray,
    color: ColorPalette.HEX.OuterSpace,
  },
  listPreviewCard: {
    white: ColorPalette.HEX.White,
    shadow: `rgba(${ColorPalette.RGB.DeepTaupe2}, 0.16)`,
    itemTitle: ColorPalette.HEX.PineTree,
    itemSubtitle: ColorPalette.HEX.SonicSilver,
    fontColor: {
      active: ColorPalette.HEX.OriolesOrange,
      empty: ColorPalette.HEX.DimGray,
    },
    separator: ColorPalette.HEX.BrightGray,
    iconBackground: [
      `linear-gradient(0deg, ${ColorPalette.HEX.PastelBlue} 0%,${ColorPalette.HEX.DimGray} 100%)`,
      `linear-gradient(to top, ${ColorPalette.HEX.Ceil}, ${ColorPalette.HEX.DarkBlueGray})`,
      `linear-gradient(0deg, ${ColorPalette.HEX.CambridgeBlue} 0%, ${ColorPalette.HEX.RussianGreen} 100%)`,
      `linear-gradient(0deg, ${ColorPalette.HEX.SilverPink} 0%, ${ColorPalette.HEX.DeepTaupe} 100%)`,
    ],
  },
  expensesSelectableList: {
    day: ColorPalette.HEX.Manatee,
    item: {
      primary: ColorPalette.HEX.DimGray,
      secondary: ColorPalette.HEX.PineTree,
      background: ColorPalette.HEX.White,
      backgroundHover: ColorPalette.HEX.FloralWhite,
      division: ColorPalette.HEX.BrightGray,
    },
  },
  profilePhotoInfo: {
    gradient: `linear-gradient(to bottom, ${ColorPalette.HEX.BrightGray4}, ${ColorPalette.HEX.Lotion})`,
    border: `solid 4px ${ColorPalette.HEX.White}`,
    editButton: ColorPalette.HEX.OriolesOrange,
    textColor: ColorPalette.HEX.PineTree,
  },
  searchBar: {
    background: `rgba(${ColorPalette.RGB.BrightGray}, 0.5)`,
  },
  receipt: {
    background: ColorPalette.HEX.White,
    divison: ColorPalette.HEX.BrightGray,
    label: ColorPalette.HEX.PineTree,
    value: ColorPalette.HEX.DimGray,
    discounts: ColorPalette.HEX.GreenPantone,
  },
  fullScreenToolTip: {
    textColor: ColorPalette.HEX.DimGray,
    imageBorder: ColorPalette.HEX.BrightGray,
    background: ColorPalette.HEX.Lotion,
  },
  radioButton: {
    active: ColorPalette.HEX.RedPigment2,
    disable: ColorPalette.HEX.DimGray,
  },
  radioCard: {
    border: ColorPalette.HEX.BrightGray,
    background: ColorPalette.HEX.White,
    title: ColorPalette.HEX.PineTree,
    subtitle: ColorPalette.HEX.DimGray,
  },
  simpleTooltip: {
    white: ColorPalette.HEX.White,
  },
  menuList: {
    boxShadow: `0 2px 16px 0 rgba(${ColorPalette.RGB.Black}, 0.1)`,
    backgroundColor: ColorPalette.HEX.White,
    borderRadius: '12px',
  },
  autoDetails: {
    background: ColorPalette.HEX.White,
    bestOptionBackground: `linear-gradient(258deg, ${ColorPalette.HEX.BlueViolet} 100%, ${ColorPalette.HEX.BlueViolet2})`,
    preApprovedBackground: `linear-gradient(258deg, ${ColorPalette.HEX.UFOGreen} 100%, ${ColorPalette.HEX.PastelGreen})`,
    costExceededColor: ColorPalette.HEX.CongoPink,
    costExceededBackground: ColorPalette.HEX.Seashell,
    infoText: ColorPalette.HEX.White,
    checkoutItem: ColorPalette.HEX.DimGray,
    checkoutTotal: ColorPalette.HEX.OuterSpace,
    checkoutTotalApproved: ColorPalette.HEX.Apple,
    checkoutTotalExceeded: ColorPalette.HEX.CongoPink,
    division: ColorPalette.HEX.AntiFlashWhite,
    border: ColorPalette.HEX.BrightGray,
    card: {
      title: ColorPalette.HEX.OuterSpace,
      boxShadow: `rgba(${ColorPalette.RGB.Black}, 0.1)`,
      arrowDown: ColorPalette.HEX.OuterSpace,
    },
    cancellationPolicies: {
      cardContent: ColorPalette.HEX.LightSilver2,
      label: ColorPalette.HEX.OuterSpace,
      policy: ColorPalette.HEX.OuterSpace,
      policyValue: ColorPalette.HEX.Manatee,
      disclaimer: ColorPalette.HEX.OuterSpace,
    },
    price: {
      title: ColorPalette.HEX.OuterSpace,
      label: ColorPalette.HEX.Manatee2,
      division: ColorPalette.HEX.LightSilver2,
      priceValue: ColorPalette.HEX.OuterSpace4,
      boxShadow: `rgba(${ColorPalette.RGB.Black}, 0.1)`,
    },
  },
};
